import React from 'react'
import styled, { keyframes } from 'styled-components'
import { LogoIcon } from '@pancakeswap/uikit'
import Page from '../Layout/Page'

const Wrapper = styled(Page)`
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-animation: spin 7s linear infinite;
  animation: spin 7s linear infinite;

  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
`
const ImageWrapper = styled.div`
img {
  height: 150px;
  width: 150px;
}
${({ theme }) => theme.mediaQueries.md} {
  img {
    height: 270px;
    width: 270px;
  }

}
`

const PageLoader: React.FC = () => {
  return (
    <Wrapper>
      <ImageWrapper>
        <img src="/images/pixel/Loader.png" alt="ifo bunny" width="200px" height="200px"/>
      </ImageWrapper>
    </Wrapper>
  )
}

export default PageLoader
